import React from 'react'
import { COLLECTION_PATH } from 'routes/paths'
import { post_event } from 'utils/analytics'
import CollectionShelf from 'components/modular/shelves/collection-shelf'
// eslint-disable-next-line no-restricted-imports
import { withApollo } from '@apollo/client/react/hoc'
import { compose } from 'utils/compose'
import { useBookCollection } from './BookCollections.hooks'
import type {
  BookCollectionProps,
  DecoratorsProps
} from './BookCollections.types'
import withLazyLoad from 'utils/with-lazy-load'
import { useTranslation } from 'i18n'

const BookCollection: React.FC<BookCollectionProps & DecoratorsProps> = ({
  client,
  contentFilter,
  isStudentView = false,
  degree
}) => {
  const title = 'Coleções Árvore'
  const { content, isLoading } = useBookCollection(
    client,
    contentFilter,
    isStudentView,
    degree,
    title
  )

  const { t } = useTranslation()

  return (
    <CollectionShelf
      loading={isLoading}
      title={t(title)}
      content={content}
      contentFilter={contentFilter}
      customClickCollection={({ name }) => {
        global.ga('send', {
          hitType: 'event',
          eventCategory: 'Metricas',
          eventAction: 'on click Colecoes Arvore',
          eventLabel: name
        })
        post_event(`Colecões Árvore/${contentFilter}`, name)
      }}
      pathHandler={COLLECTION_PATH}
    />
  )
}
export default compose<React.FC<BookCollectionProps>>(
  withApollo,
  withLazyLoad({ once: true, height: 310, resize: true })
)(BookCollection)
